import React from 'react';
import { cloneDeep } from 'lodash';

import ItemWithVariant from './ItemWithVariant';
import ItemWithoutVariant from './ItemWithoutVariant';
import ItemNameAndRemoveButton from './ItemNameAndRemoveButton';

const initialItemLink = (links, item_link_id) => {
  const comparisonFunc = ele => ele.item_link_id === item_link_id;
  return links.find(comparisonFunc);
};

const TableRows = ({ item_link_id, links }) => {
  const itemLink = initialItemLink(links, item_link_id);

  if (
    itemLink.variant &&
    Array.isArray(itemLink.variant) &&
    itemLink.variant.length !== 0
  ) {
    const variantAtRootLevel = cloneDeep(itemLink.variant);
    const itemVariants = variantAtRootLevel[0].variants;
    return (
      <>
        <ItemNameAndRemoveButton itemLink={itemLink} />
        {itemVariants.map((itemVariant, itemVariantIndex) => (
          <ItemWithVariant
            key={itemVariant.variant_id}
            itemVariant={itemVariant}
            itemVariantIndex={itemVariantIndex}
          />
        ))}
      </>
    );
  }

  return <ItemWithoutVariant itemLink={itemLink} />;
};

export default TableRows;
